import { HttpClient, HttpResponseBase } from '@angular/common/http';
import { ObservableInput, of, Observable } from 'rxjs';

export type HttpRequestOptions = NonNullable<Parameters<HttpClient['request']>[2]>;

export class ClientBase {
  optionsTransformer?: (options: HttpRequestOptions) => ObservableInput<HttpRequestOptions>;
  protected transformOptions(options: HttpRequestOptions): ObservableInput<HttpRequestOptions> {
    if (this.optionsTransformer) {
      return this.optionsTransformer(options);
    }
    return of(options);
  }

  protected transformResult<T>(
    url: string,
    response: HttpResponseBase,
    processor: (res: HttpResponseBase) => Observable<T>
  ): Observable<T> {
    return processor(response);
  }
}
